import { render, staticRenderFns } from "./sysuser_auth_copy.vue?vue&type=template&id=5b8e2680&scoped=true"
import script from "./sysuser_auth_copy.vue?vue&type=script&lang=js"
export * from "./sysuser_auth_copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8e2680",
  null
  
)

export default component.exports